import { useDispatch } from 'store/hooks';
import { useCallback } from 'react';
import { updateAppSettings } from './actions';
import { AppSettingsState } from './AppSettingsState';

export const useDispatchUpdateAppSettings = () => {
    const dispatch = useDispatch();
    return useCallback((delta: Partial<AppSettingsState>) => {
        dispatch(updateAppSettings(delta));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export const useDispatchHideAppToolbar = () => {
    const dispatch = useDispatchUpdateAppSettings();
    return () => {
        dispatch({ hideAppToolbar: true });
    };
};

export const useDispatchShowAppToolbar = () => {
    const dispatch = useDispatchUpdateAppSettings();
    return () => {
        dispatch({ hideAppToolbar: false });
    };
};
